interface SettingsListItem {
    name?: string;
    displayName?: string;
    keyName?: string;
    fantasyName?: string;
}

export const buildSettingsSearchParams = (field: string, value: string): Record<string, string> => {
    const search = value.trim();
    if (!search) return {};

    return field === 'Empresas Terceirizadas'
        ? { fantasyName: search }
        : { name: search };
};

export const getSettingsItemPrimaryLabel = (field: string, item: SettingsListItem): string => {
    if (field === 'Chaves de Especificação') {
        return item.keyName || item.displayName || '';
    }

    return item.name || item.displayName || item.keyName || item.fantasyName || '';
};
